<template>
  <div
    class="footer-main"
    style="
      font-family: -apple-system-font, Helvetica Neue, Helvetica,
        STHeiTi, sans-serif;
    "
  >
    <div class="container">
      <el-row
        style="
          display: flex;
          gap: 100px;
          justify-content: center;
          align-items: flex-start;
        "
      >
        <el-col :xs="24" :md="14" :lg="9" :xl="11" style="width: 401px">
          <div class="contact">
            <div style="display: flex; align-items: center">
              <div>
                <img
                  src="../assets/images/eiiplat_logo.png"
                  style="width: 80px; margin-top: 3px"
                />
              </div>
              <span class="h1">环境产业互联网平台</span>
            </div>
            <div
              style="
                color: #fff;
               
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                letter-spacing: 1.68px;
               
                margin-bottom: 8px;
              "
            >
              Environment Industry Internet Platform
            </div>
            <div
              style="
                color: rgba(255, 255, 255);
               
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
               
              "
            >
              地址：{{ footer.address }}
            </div>
            <div class="h3" style="margin-top: 32px">
              <img
                src="../assets/images/ic_gz_ph.png"
                alt=""
                style="width: 18px; margin-right: 4px"
              />
              <span> 咨询： </span>
            </div>
            <p class="pText">{{ footer.phoneOne }} / {{ footer.phoneTwo }}</p>
            <div class="h3" style="margin-top: 24px">
              <img
                src="../assets/images/ic_gz_em.png"
                alt=""
                style="width: 18px; margin-right: 4px"
              />
              <span> 邮箱: </span>
            </div>
            <p class="pText">
              {{ footer.mailbox }}
            </p>
          </div>
        </el-col>
        <el-col :xs="24" :md="5" :lg="8" :xl="7" style="width: 419px">
          <div class="navigation">
            <div style="margin-right: 20px; width: 75px">
              <p class="h5">产品服务</p>
              <ul class="list">
                <li
                  v-for="(item, index) in footer.columnModuleList"
                  :key="item.id"
                  v-if="item.aboutPlatform == '3'"
                  @click="handleEntryClick(item)"
                >
                  {{ item.columnName }}
                </li>
              </ul>
            </div>
            <div style="margin-right: 20px; width: 75px">
              <p class="h5">解决方案</p>
              <ul class="list">
                <li
                  v-for="(item, index) in footer.columnModuleList"
                  :key="item.id"
                  v-if="item.aboutPlatform == '2'"
                  @click="handleEntryClick(item, index)"
                >
                  {{ item.columnName }}
                </li>
              </ul>
            </div>
            <div style="margin-right: 20px; width: 75px">
              <p class="h5">典型案例</p>
              <ul class="list">
                <li
                  v-for="(item, index) in footer.columnModuleList"
                  :key="item.id"
                  v-if="item.aboutPlatform == '2'"
                  @click="handleEntryClick(item, index)"
                >
                  {{ item.columnName }}
                </li>
              </ul>
            </div>
            <div style="width: 75px">
              <p class="h5">快捷入口</p>
              <ul class="list">
                <li
                  v-for="(item, index) in footer.columnModuleList"
                  :key="item.id"
                  v-if="item.aboutPlatform == '1'"
                  @click="handleEntryClick(item, index)"
                >
                  {{ item.columnName }}
                </li>
              </ul>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :md="5" :lg="6" :xl="6" style="width: 260px">
          <div class="qrCode">
            <div
              style="margin-right: 20px"
              v-for="v in footer.footerFollowList"
              :key="v.id"
            >
              <img :src="v.codePicture" />
              <p class="h6">{{ v.subtitle }}</p>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="width: 1280px">
          <div class="records">
            <div
              style="text-align: center; margin-top: 10px; margin-bottom: 10px"
            >
              <span>平台总则 |</span>
              <span>隐私政策 |</span>
              <span>法律声明 |</span>
              <span>关于我们 |</span>
              <span>联系我们 |</span>
              <span>加入我们</span>
            </div>
            <div>
              <span>{{ footer.copyright }}</span>
              <img src="../assets/images/beian.png" />
              <span>{{ footer.recordNo }}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { detailFooter } from "@/api";
export default {
  name: "Footer",
  data() {
    return {
      footer: {
        address: "",
        copyright: "",
        createBy: "",
        footerFollowList: [],
        columnModuleList: [],
        mailbox: "",
        phoneOne: "",
        phoneTwo: "",
        recordNo: "",
        updateBy: "",
        updateTime: "",
      },
    };
  },
  created() {
    // 获取 页脚数据
    this.footerData();
  },
  methods: {
    // 获取页脚数据
    async footerData() {
      const res = await detailFooter();
      this.footer = res.data;
      // this.footer.columnModuleList.push({ columnName: "开发者社区", desc: 'community', aboutPlatform: '1' })
      this.footer.columnModuleList.push({
        columnName: "政府",
        desc: "solution",
        aboutPlatform: "2",
      });
      this.footer.columnModuleList.push({
        columnName: "企业",
        desc: "solution",
        aboutPlatform: "2",
      });
      this.footer.columnModuleList.push({
        columnName: "环卫产品",
        desc: "ProductService",
        aboutPlatform: "3",
      });
      this.footer.columnModuleList.push({
        columnName: "产品服务",
        desc: "productService",
        aboutPlatform: "3",
      });
      this.footer.columnModuleList.push({
        columnName: "环保产品",
        desc: "ProductService",
        aboutPlatform: "3",
      });
      this.footer.columnModuleList.push({
        columnName: "通用产品",
        desc: "ProductService",
        aboutPlatform: "3",
      });
    },
    handleEntryClick(item) {
      switch (item.desc) {
        case "home":
          this.$router.push({ path: "/" });
          break;
        case "productService":
          this.$router.push({ path: "/ProductService" });
          break;
        case "solution":
          this.$router.push({ path: "/Solution" });
          break;
        case "ecoPartner":
          this.$router.push({ path: "/EcoPartner" });
          break;
        case "appMarket":
          window.open(
            `http://app.eiiplat.com/#/index?userName=${localStorage.userName}&token=${localStorage.usertoken}`
          );
          break;
        case "information":
          this.$router.push({ path: "/Information" });
          break;
        case "aboutUs":
          this.$router.push({ path: "/AboutUs" });
          break;
        case "community":
          this.$router.push({ path: "/DeveloperCommunity" });
          break;
      }
    },
  },
};
</script>


<style lang="scss">
.footer-main {
  display: flex;
  justify-content: center;
  width: 100%;
  min-height: 350px;
  color: #fff;
  // background: url(../assets/images/foot_bgi.png) no-repeat;
  // background-size: 100% 100%;
  background-color: #464645;
}

.container {
  width: 1280px;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  justify-content: center;
  padding-bottom: 60px;
}

.contact {
  display: inline-block;
  // height: 255px;
  margin-top: 50px;
  color: #fff;

  img {
    width: 24px;
    vertical-align: baseline;
  }

  .h1 {
    display: inline-block;
    font-size: 22px;
    margin-bottom: 4px;
    font-style: normal;
    font-weight: 700;
    margin-left: 7px;
  }

  .h2 {
   
    font-size: 30px;
    margin: 0;
  }

  .h3 {
    
    font-size: 14px;
    margin: 0;
    color: #fff;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    /* 184.615% */
    letter-spacing: -1px;
    display: flex;
    margin-bottom: 4px;
    span{
      color: #fff;
    }
  }

  .pText {
    color: #fff;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    /* 150% */
  }
}

.navigation {
  display: flex;
  margin-top: 50px;

  .h5 {
    color: var(--Color-2, #fff);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
  }

  .underline {
    width: 36px;
    height: 2px;
    margin-top: 5px;
    background: #d7000f;
  }

  .list {
    padding: 0;
    list-style: none;
   
    font-weight: 400;
    line-height: 2.5;
    margin: 0;

    li {
      display: block !important;
      color: #fff;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
    }

    li:hover {
      cursor: pointer;
    }
  }
}

.qrCode {
  display: flex;
  align-items: center;
  margin-top: 70px;
  margin-bottom: 10px;
  img {
    width: 120px;
    height: 120px;
  }

  .h6 {
    margin: 0;
    // font-size: 14px;
    text-align: center;
    margin-top: 14px;
    color: #fff;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
}

.records {
  width: 100%;
  text-align: center;
  margin-top: 1%;
  padding-top: 10px;
  border-top: 1px solid rgba(236, 240, 241, 0.4);

  span {
    color: #fff;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    /* 200% */
  }

  img {
    width: 18px;
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue